import React from "react";
import { useFeatureFlag } from "../../../../launch-darkly/useLaunchDarkly";
import { Header, SlideLayout, Text } from "../../shared-components";
import { IconVariant } from "../../shared-components/Header";
import linksExampleImage from "./assets/links-demo.svg";
import linksImageV2 from "./assets/links.svg";

const Image = () => {
  return <img src={linksExampleImage} className="cw-w-full md:cw-h-[475px]" />;
};

const ImageV2 = () => {
  return <img src={linksImageV2} className="cw-w-full md:cw-h-[475px] cw-mt-3" />;
};

export const LinksSlide = () => {
  const [isOnAIOnboarding] = useFeatureFlag("rollout-ai-onboarding");

  if (isOnAIOnboarding) {
    return (
      <SlideLayout>
        <Header>Share your availability, instantly</Header>
        <Text>
          No more back-and-forth. Scheduling Links allow you to book internal and external meetings
          at the optimal time.
        </Text>
        <ImageV2 />
      </SlideLayout>
    );
  }

  return (
    <SlideLayout>
      <Header iconVariant={IconVariant.Burst}>Share your availability, instantly</Header>
      <Text>
        Clockwise Scheduling Links allow you to book external meetings at the best time for
        everyone, based on your preferences.
      </Text>
      <Image />
    </SlideLayout>
  );
};
